import { render, staticRenderFns } from "./onePlayerNoBlob.vue?vue&type=template&id=14862b8d&"
import script from "./onePlayerNoBlob.vue?vue&type=script&lang=js&"
export * from "./onePlayerNoBlob.vue?vue&type=script&lang=js&"
import style0 from "./onePlayerNoBlob.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports